import axios from "axios"

/**
 * @deprecated axios.instanceが隠蔽されている ./httpRequest.ts httpRequest を利用すること
 */
export const jsonClient = axios.create({
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
})
